export const staticNotes = {
    SPM_REWORK_NOTE: "SPM app under rework; KPIs may change",
    ARCHLET_BU_NOTE: "Archlet does not have BU-level details for sectors: Europe, PBNA, PFNA, LATAM. Thus, only Sector-level details are available for these sectors.",
    COMAN_CARD_NOTE: "This data is available only for AMESA users.",
    DATA_UNAVAILABLE_NOTE: "Data is not available for the given filter combination. Please adjust your selection.",
    COMAN_UNAVAILABLE_NOTE: "This capability is available only in AMESA.",
    MYRIS_OPEX_NOTE: "For APAC, AMESA - Actual Savings are just OPEX savings. For rest, it is OPEX + CAPEX.",
    SPEND_EU_NOTE: "For Europe Sector, there is a discrepancy of  ~$ 0.4 MN for July 2025, which the Spend team is resolving.",
    MYRIS_TOUCHLESS_PO_NOTE: "Touchless PO - % of POs processed without any manual intervention",
    EDF_NOTE: "EDF / API integrated",
    CONTRACT_EDF_NOTE: "LATAM data is coming from ariba sourcing",
    SUPPLIER_DISCOVERY_EDF_NOTE: "The data is coming from API"

}